(function () {
  if (window.__cblCardColors) return;
  window.__cblCardColors = true;
  var cache = {};
  function money(cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' kr'; }
  function apply(card, el, url, p) {
    card.classList.remove('cbl-loading');
    card.setAttribute('data-product-id', p.id);
    card.classList.add('cbl-swapped');
    card.querySelectorAll('a.product-link, a.quickbuy-toggle').forEach(function (a) { a.href = url; a.setAttribute('aria-label', p.title); });
    var t = card.querySelector('.product-block__title'); if (t) t.textContent = p.title;
    var pr = card.querySelector('.product-price__amount'); if (pr) pr.textContent = money(p.price);
    var src = p.featured_image; if (src) { src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=900'; }
    var img = card.querySelector('.product-block__image--primary img');
    if (img && src) {
      img.removeAttribute('srcset'); img.removeAttribute('data-srcset'); img.removeAttribute('sizes');
      img.classList.remove('lazyload', 'lazyload--manual', 'lazyloading'); img.classList.add('lazyloaded');
      img.src = src; img.setAttribute('data-src', src); img.alt = p.title;
      var pic = img.closest('picture'); if (pic) pic.querySelectorAll('source').forEach(function (s) { s.remove(); });
    }
    var bg = card.querySelector('.product-block__image--primary .rimage-background');
    if (bg && src) { bg.style.backgroundImage = 'url(' + src + ')'; bg.classList.add('lazyloaded'); }
    var sizes = card.querySelector('.product-block-options[data-option-name="Størrelse"]');
    if (sizes && p.variants) {
      var map = {};
      p.variants.forEach(function (v) { map[v.option1] = !!v.available; });
      sizes.querySelectorAll('.product-block-options__item').forEach(function (it) {
        var name = it.getAttribute('data-option-item');
        if (name in map) it.classList.toggle('product-block-options__item--unavailable', !map[name]);
      });
    }
    card.querySelectorAll('.cbl-card-colors__item').forEach(function (x) { x.classList.remove('is-active'); });
    el.classList.add('is-active');
  }
  document.addEventListener('click', function (e) {
    var el = e.target.closest('.cbl-card-colors__item');
    if (!el) return;
    var card = el.closest('.product-block');
    if (!card) return;
    if (el.classList.contains('is-active')) return;
    e.preventDefault();
    var handle = el.getAttribute('data-cbl-handle');
    var url = '/products/' + handle;
    card.classList.add('cbl-loading');
    if (cache[handle]) { apply(card, el, url, cache[handle]); return; }
    fetch(url + '.js').then(function (r) { return r.json(); }).then(function (p) { cache[handle] = p; apply(card, el, url, p); }).catch(function () { window.location.href = url; });
  });
})();
